<template>
  <div>
    <v-container
      v-if="!isLoading"
      fluid>
      <v-progress
        v-model="inProgress"></v-progress>
      <v-error-dialog
        v-model="error"
        :message="errorMessage"
        />
      <v-snackbar
        v-model="bar"
        top>
        <span>{{ barText }}</span>
      </v-snackbar>
      <v-teacher-info
        :teacher=teacher
        :student=student
        @close-button-click="toStudent"
        @offer-button-click="isOffer=true"
        @break-button-click="breakOffRelations"
        @message-button-click="isMessage=true" />
      <v-dialog
        :value=isOffer
        scrollable
        persistent
        width=800>
        <v-offer-lesson-card
        v-model=offerInput
        :teacher=teacher
        :student=student
        @close-button-click="isOffer=false"
        @submit-button-click="sendOffer"
        />
      </v-dialog>
      <v-message-window
        v-if="isMessage"
        :teacher=teacher
        :isOpen=isMessage
        @open-button-click="isMessage=true"
        @close-button-click="isMessage=false" />
    </v-container>
    <loading
      v-else/>
  </div>
</template>

<script>
import VTeacherInfo from "@/components/organisms/parent/VTeacherInfo.vue"
import VOfferLessonCard from "@/components/organisms/parent/VOfferLessonCard.vue"
import VMessageWindow from "@/components/organisms/parent/VMessageWindow.vue"
import Loading from '@/components/organisms/Loading.vue'
import VProgress from '@/components/organisms/VProgress.vue'
import VErrorDialog from '@/components/organisms/parent/VErrorDialog.vue'
import { firestore } from "@/repository/client/firestore"
import { LessonOfferRepository } from "@/repository/LessonOfferRepository"
import { RelationsBreaker } from "@/service/request/break-off-relations"

export default {
  components: {
    VTeacherInfo,
    VOfferLessonCard,
    VMessageWindow,
    Loading,
    VProgress,
    VErrorDialog
  },
  props: {
    teacher: {
      type: Object,
      required: true
    },
    studentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      student: null,
      isOffer: false,
      offerInput: {
        schedule: {
          day: "",
          startTime: "",
          endTime: ""
        }
      },
      isMessage: false,
      isLoading: true,
      bar: false,
      barText: "",
      inProgress: false,
      error: false,
      errorMessage: ""
    }
  },
  methods: {
    toStudent() {
      this.$emit('close-button-click')
    },
    async sendOffer() {
      const lessonOfferRepo = new LessonOfferRepository(firestore)
      const lesson = {
        teacherId: this.teacher.getId(),
        parentId: this.student.getParentId(),
        studentId: this.student.getId(),
        schedule: this.offerInput.schedule,
        wage: this.offerInput.wage,
        note: this.offerInput.note ? this.offerInput.note : 'なし'
      }
      const offer = lessonOfferRepo.put(
        lesson,
        lesson.parentId,
        lesson.teacherId
      )
    },
    async breakOffRelations() {
      this.inProgress = true
      try {
        const breaker = new RelationsBreaker(firestore, this.parent, this.student)
        this.parent = await breaker.execute(this.teacher.getId())
        this.$store.commit('loginAsParent', this.parent),
        this.barText = `${this.teacher.fullName()} 先生の担当を解除しました。`
        this.inProgress = false
        this.bar = true
        this.toStudent()
      } catch (e) {
        this.inProgress = false
        this.errorMessage = e.message
        this.error = true
      }
    }
  },
  async created () {
    this.parent = this.$store.getters.parent
    this.student = this.parent.findStudent(this.studentId)
    this.isLoading = false
  }
}
</script>
